import { css } from 'design'
import { Stack } from 'primitives/containers'
import React from 'react'
import { useSelector } from 'react-redux'

import { WidgetHeaderBar } from '../../components/live_chat_widget/widget_header_bar'
import { getSelectedWelcomeMessage } from '../../reduxes/slices/welcome_messages/selectors'
import { WidgetPageContainer } from './widget_page_container'

type Props = {
  heading: string
  children: any
}

export const OptionsPageContainer = ({ heading, children }: Props) => {
  const welcomeMessage = useSelector(getSelectedWelcomeMessage)

  return (
    <WidgetPageContainer>
      <WidgetHeaderBar />
      {welcomeMessage && (
        <img
          src={welcomeMessage.welcome_video_poster}
          className={imgStyles()}
        />
      )}
      <div className={gradientBGStyles()} />
      <div className={headingStyles()}>{heading}</div>
      <Stack
        gap={3}
        // eslint-disable-next-line
        // @ts-ignore
        css={{
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute !important',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '100%',
          padding: '0 $4',

          'button, .widget-phone-number': {
            width: '100%',
            padding: '$3',
            position: 'relative',
            pointerEvents: 'auto !important',

            svg: {
              position: 'absolute',
              left: 10,
            },
          },
        }}
      >
        {children}
      </Stack>
    </WidgetPageContainer>
  )
}

const headingStyles = css({
  fontSize: '$4',
  color: 'white',
  marginTop: '$8',
})

const imgStyles = css({
  position: 'absolute',
  width: '100%',
  height: '100%',
})

const gradientBGStyles = css({
  width: '100%',
  height: '100%',
  position: 'absolute !important',
  background: 'linear-gradient(0deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.7) 100%)',
})
